import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/css/general.css";
import "./assets/css/index.css";
import "./assets/css/pages-icons.css";
import "./assets/css/pages-sidebar.css";

import Homepage from "./components/Home";
import { Toaster } from "react-hot-toast";

import { PatientProvider } from "./contexts";
import PageLayout from "./components/layouts/PageLayout";
import NotFound from "./components/pages/NotFound";
import ResetPassword from "./components/layouts/ResetPassword";

// Define a component for the 404 page

function App() {
  return (
    <PatientProvider>
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/doctor/*" element={<PageLayout />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Render the NotFound component for unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </PatientProvider>
  );
}

export default App;
